<template>
  <div class="customization-upload-image-wrapper">
    <div v-if="customConfig?.length">
      <div v-for="(config, i) in customConfig" :key="i">
        <div v-if="config && config.type == 'options'" class="mb-sm">
          <div class="customization-upload-image-upload-title">
            {{ config?.title || 'Choose Option *' }}
          </div>
          <sib-select :id="config?.title ? `custom-${config.title}` : 'custom-choose-option'" :name="config?.title ? `custom-${config.title}` : 'custom-choose-option'" size="md" :options="config?.value?.split(',').map((item: any) => ({ value: item, label: item }))"
            :value="config.customValue" @input="(val:string) => {config.customValue = val}">
          </sib-select>
        </div>
        <div v-else-if="config && config.type == 'text'" class="mb-sm">
          <div class="customization-upload-image-upload-title">
            {{ config?.title || 'Enter Name *' }}
          </div>
          <sib-input :id="config?.title ? `custom-${config.title}` : 'custom-enter-name'" :name="config?.title ? `custom-${config.title}` : 'custom-enter-name'" v-model="config.customValue" :placeholder="config?.value || 'Eg: Emma, Lyly, ...'" size="md"
            round="md"></sib-input>
        </div>
      </div>
    </div>

    <div v-else-if="customName" class="mb-sm">
      <div class="customization-upload-image-upload-title">
        Enter Your Name *
      </div>
      <sib-input v-model="customYourName" size="md" round="md"></sib-input>
    </div>

    <div v-if="images && images?.number > 1">
      <div v-if="images && images.type != 'fixed'" class="customization-upload-image-upload-title">Select Number of
        Photos
      </div>
      <sib-select v-if="images && images.type != 'fixed'" size="md" :options="imageNumberOptionList"
        :value="imageNumberUpload" @input="changeImageNumberUploadOption">
      </sib-select>

      <div v-for="(item, i) in Number(imageNumberUpload)" :key="i" class="custom-upload-image-style-transfer">
        <StyleTransferUpload v-bind="{
          title: `Upload Photo #${i + 1}`,
          id: `${id}-${i}`,
          selectImageButtonCustomily,
          customizationTemplate,
          photoNumber: i + 1,
          listImageUploadSelected
        }" @upload="() => numberUploadAiImg++">
        </StyleTransferUpload>
      </div>

      <div class="mt-sm" style="display: flex; align-items: center;" :class="{'disable-button': loading}">
        <div
          class="generate-button sib-button sib-button--primary sib-button--md sib-button--width-default sib-button--round-md"
          @click="transferMultipleImage">
          <div v-if="loading" class="generate-loading lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div>Generate Preview</div>
        </div>
        <span style="height: 40px;transform: translateY(2px);" class="tooltip-image-processing" v-show="loading">
          {{ imageProcessingText }}
          {{ percentProcessed ? `${percentProcessed}%` : '' }}
        </span>
        <span style="height: 40px;line-height: 1;" class="remove-custom-upload-image"
          v-show="isSuccessUpload && !loading" @click="removeImage">X</span>
      </div>
      <div class="customization-upload-image-wrapper-message" v-show="isShowMessage && !isRemoveImage"
        :class="messageClasses">
        {{ messageImageUpload }}
      </div>

      <div v-show="titleCustomConfigHasNotValue"
        class="customization-upload-image-wrapper-message text-secondary mt-xs">
        {{ `${titleCustomConfigHasNotValue?.replace('*', '').trim() } is required` }}
      </div>

      <div v-show="!hasCustomYourNameRequired" class="customization-upload-image-wrapper-message text-secondary mt-xs">
        {{ `Your Name is required` }} <br />
      </div>

      <div class="customization-upload-image-wrapper-message text-secondary mt-xs"
        v-show="!isEnoughNumberImagesRequired">
        {{ `You need ${imageNumberUpload} photos to start generating.` }}
      </div>
    </div>

    <template v-else-if="props.onlyText">
      <button
        type="button"
        class="music-action-button"
        @click="handleGenImageFromOnlyText"
        :disabled="statusGenAIText === 'waiting'"
      >
        <span v-if="statusGenAIText === 'waiting'">⏳ Generating...</span>
        <span v-else>Create Your Design </span>
      </button>

      <!-- Progress Bar -->
      <div v-if="showProgress" class="music-progress-wrapper">
        <div class="music-progress-bar">
          <div
            class="music-progress-fill"
            :style="{ width: progress + '%' }"
          ></div>
        </div>
        <div class="music-progress-text">
          Generating image... {{ Math.floor(progress) }}%
        </div>
      </div>
    </template>

    <template v-else>
      <div v-if="customName || customConfig?.length" class="customization-upload-image-upload-title mt-sm">
        Upload Photo
      </div>
      <RadioGroup v-if="isShowOptions" type="image" :group="id" :options="optionList" :loading="loading"
        v-model="templateIdSelected" class="mb-sm"></RadioGroup>
      <CustomFileUpload :id="id">
      </CustomFileUpload>
      <span class="tooltip-image-processing" v-show="loading">
        {{ imageProcessingText }}
        {{ percentProcessed ? `${percentProcessed}%` : '' }}
      </span>
      <span class="remove-custom-upload-image" v-show="isSuccessUpload && !loading" @click="removeImage">X</span>
      <span class="customization-upload-image-wrapper-message" v-show="isShowMessage && !isRemoveImage"
        :class="messageClasses">
        {{ messageImageUpload }}
      </span>

      <div v-show="!hasCustomYourNameRequired" class="customization-upload-image-wrapper-message text-secondary mt-xs">
        <br /> Please enter your name.
      </div>
      <div v-show="titleCustomConfigHasNotValue" class="customization-upload-image-wrapper-message text-secondary mt-xs">
        <br /> {{ `${titleCustomConfigHasNotValue?.replace('*', '').trim()} is required` }}
      </div>
    </template>

    <div class="rate-limit-transfer-message" v-show="exceedTheLimit && !isTechLeversphereBypass">
      <b>You’ve used all your free previews.</b>
      <br />Add this product to cart to unlock <b>10 more preview attempts.</b>
    </div>

    <div
      v-if="isStyleTransferVideo && previewVideoUrl"
      class="style-transfer-video-preview-wrap"
    >
      <div class="ai-video-container">
        <video
          :key="previewVideoUrl"
          class="style-transfer-video-preview"
          :src="previewVideoUrl"
          controls
          controlsList="nodownload"
          @contextmenu.prevent
          playsinline
          preload="metadata"
        />
        <div class="ai-video-watermark" :style="watermarkOverlayStyle"></div>
      </div>
    </div>

    <div v-if="aiStyleTransferRecently?.length">
      <div class="ai-style-transfer-history-title">History</div>
      <div class="ai-style-transfer-recently">
        <div v-for="(item, index) in aiStyleTransferRecently.filter(i => i.option_sort_id == String(props.optionSortId))" :key="index" class="ai-style-transfer-recently__item"
          :class="{
            'ai-style-transfer-recently__item--active': aiStyleTransferRecentlyIndexSelected == index
          }" @click="chooseImageAiStyleTransferRecently(index)">
          <div class="ai-style-transfer-recently__item--image">
            <img
              v-if="item.output_is_video"
              :src="item.image"
              class="ai-style-transfer-recently__media"
              alt=""
            />
            <img v-else :src="item.image" class="ai-style-transfer-recently__media" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="isStyleTransferVideo" class="style-transfer-video-create-wrap mt-sm">
      <p v-if="videoGenErrorMessage" class="style-transfer-video-note style-transfer-video-note--error">
        {{ videoGenErrorMessage }}
      </p>
      <p
        v-else-if="videoGenConsumed && !previewVideoUrl && styledImageUrlForVideo"
        class="style-transfer-video-note"
      >
        You have already used your video generation for this product within 24 hours.
      </p>
    </div>

    <input type="hidden" v-if="imageUploadUrl" :name="`properties[_style-transfer-image-upload-url]`"
      :value="imageUploadUrl" />
    <input type="hidden" v-if="imageAiUrlSelectedForCheckout" :name="`properties[_style-transfer-image-output-url]`"
      :value="imageAiUrlSelectedForCheckout" />
    <input type="hidden" v-if="hasCustomValues" :name="`properties[_input-details]`"
      :value="aiPersonalizationDetails" />
    <ProductVerificationPopup
      v-model:show="showVerificationPopup"
      :number-upload-ai-img="numberUploadAiImg"
      :product-id="productStore?.product?.id"
      @success="handleVerificationSuccess"
    />
    <input
      v-if="isStyleTransferVideo && previewVideoUrl"
      type="hidden"
      :name="`properties[_style-transfer-video-url]`"
      :value="previewVideoUrl"
    />
    <ProductAiUnlimitedPassPopup
      v-model:show="showPaywallPopup"
      :product-id="productStore?.product?.id"
      :number-upload-ai-img="numberUploadAiImg"
      @addToCart="handlePaywallAddToCart"
      @verified="handlePaywallVerified"
      @paywallException="handlePaywallException"
    />
    <client-only v-if="isTargetProductForGame">
      <PopupGame
        :show="show"
        v-model:game-name="gameName"
        :intro-component="introComponent"
        :data="gameData"
        @close="closeGame"
      />
    </client-only>
    <client-only v-if="isTargetProductForLoadingText">
      <PopupLoadingText
        :show="showLoadingTextPopup"
        :data="{
          image: imageSelected || imageUploadUrl,
          progress: percentProcessed,
          loading: loading,
          isSuccess: isSuccessUpload
        }"
        @close="showLoadingTextPopup = false"
      />
    </client-only>
  </div>
</template>

<script lang="ts" setup>
import { computed, h, onMounted, ref, watch, onBeforeMount, onBeforeUnmount, onUnmounted, defineAsyncComponent } from 'vue'
import FileUpload from '@/ui-kits/FileSelect.vue'
import RadioGroup from '@/ui-kits/RadioGroup.vue'
import Logger from '@/services/log'
import useCustomizationStore from '@/store/customization'
import { useRoute } from 'vue-router'
import {
  CUSTOMIZATION_UPLOAD_IMAGE_WRAPPER_CLASS,
  EVENT_CUSTOM_UPLOAD_IMAGE,
  QUERY_STRING_NO_CACHE,
  EVENT_INCREASE_AI_TRANSFER_LIMITED,
  EVENT_CUSTOM_UPLOAD_STYLE_TRANSFER_IMAGE,
  SEVEN_DAYS_IN_MILLISECONDS,
  REMOVE_IMAGE_BUTTON_CUSTOMILY_SELECTOR,
  CUSTOMILY_OPTION_SORT_ID_WRAPPER_SELECTOR,
  CACHE_KEY_CUSTOMILY_PERSONALIZED,
  CACHE_KEY_PRODUCT_AI_EMAIL_VERIFIED,
  CACHE_KEY_PRODUCT_AI_UPLOAD_COUNT,
  CACHE_KEY_PRODUCT_AI_VERIFIED_EMAIL,
  SHOP_DOMAIN,
  cloneDeep,
  COOKIE_KEY_KLAVIYO_EMAIL
} from '@/utils'
import { CookieManager } from '@/services/cookie'
import useUserStore from '@/store/user'
import useCustomerStore from '@/store/customer'
import useCartStore from '@/store/cart'
import ProductVerificationPopup from '@/components/product/ProductVerificationPopup.vue'
import ProductAiUnlimitedPassPopup from '@/components/product/ProductAiUnlimitedPassPopup.vue'
import EventBus from '@/services/eventbus'
import { CustomizationTemplate } from '@/types'
import { useProductCustomization } from './composables/ProductCustomization'
import useProductStore from '@/store/product'
import CacheService, { getJSONfromCacheResponse } from '@/services/cache'
import { isProductHasTags } from '@/utils/product'
import StyleTransferUpload from './StyleTransferUpload.vue'
import Analytics from '@/services/analytics'
import getDeviceId from '@/utils/device'
import {
  getLocationIpForRateLimit,
  sanitizeIpForRateLimitKey,
} from '@/services/location'
import Http from '@/services/http'
import { isOnServer } from '@/utils/ssr';

import { usePopupGame } from '@/composables/usePopupGame'
import useABTestStoreV2 from '@/composables/abtest/store'
import { abTestGlobalKey } from '@/composables/abtest/abtestV2'
import { PDP_GAME_EXPERIMENT_CAMPAIGN } from '@/composables/abtest/contexts/abtestContextPopupGame'
import { PDP_LOADING_TEXT_EXPERIMENT_CAMPAIGN } from '@/composables/abtest/contexts/abtestContextPopupLoadingText'

const PopupGame = defineAsyncComponent(
  () => import('@/components/games/PopupGame.vue')
)
const PopupLoadingText = defineAsyncComponent(
  () => import('@/components/product/PopupLoadingText.vue')
)

const { show, gameName, introComponent, gameData, openGame, closeGame } = usePopupGame()

const backendUrl = import.meta.env.VITE_BACKEND_SERVICE_API_URL || ''

const productStore = useProductStore()
const abtestStore = useABTestStoreV2()
const isTargetProductForGame = computed(() => {
  return false
  return abtestStore.isReady && abtestStore.code === PDP_GAME_EXPERIMENT_CAMPAIGN.code && abtestStore.variant === abTestGlobalKey.groupTreatment
})
const isTargetProductForLoadingText = computed(() => {
  return abtestStore.isReady && abtestStore.code === PDP_LOADING_TEXT_EXPERIMENT_CAMPAIGN.code && abtestStore.variant === abTestGlobalKey.groupTreatment
})
const showLoadingTextPopup = ref(false)

const customizationStore = useCustomizationStore()
const route = useRoute()
const {
  convertImageLinkToFileList,
  changeFileImageCustomily,
  startUpload,
  finishUpload,
  percentProcessed,
} = useProductCustomization({ registerVariantWatcher: false })

const props = withDefaults(
  defineProps<{
    id: string
    inputFileCustomily: Element
    selectImageButtonCustomily: Element
    removeImageButtonCustomily: HTMLElement
    customizationTemplate: CustomizationTemplate
    optionSortId: string
    templateId?: string
    customName?: string | number | null
    customilyElementWrapper: HTMLElement
    images?: any,
    custom?: any,
    onlyText?: any,
    isVideo?: any
  }>(),
  {}
)


let options = props.customizationTemplate.templates.map((option) => ({
  id: option.template_id,
  name: option.name || option.title,
  image: option.image,
  value: option.template_id,
  is_music: option.is_music || false,
}))

// CHỈ sản phẩm AI_multi_pose: host swap template tại chỗ (không remount) nên child
// phải tự phản ứng props đổi. Flow khác giữ nguyên `options` ở trên, không đụng.
const isMultiPose = isProductHasTags(productStore.product, ['AI_multi_pose'])
const multiPoseOptions = ref<any[]>(isMultiPose ? options : [])
const optionList = computed<any[]>(() => (isMultiPose ? multiPoseOptions.value : options))

const messageImageUpload = computed(() =>
  isSuccessUpload.value ? successfullUploadMessage : errorUploadMessage.value
)
const messageClasses = computed(() =>
  isSuccessUpload.value
    ? textPrimaryClass
    : `${textSecondaryClass} ${CUSTOMIZATION_UPLOAD_IMAGE_WRAPPER_CLASS}-message--error`
)

const templateIdDefault = computed(() => {
  const templateIdOriginal = '0000'
  const index = optionList.value.findIndex(
    (option) => option.value === templateIdOriginal
  )
  return index > -1 ? templateIdOriginal : optionList.value[0].value
})

const isShowOptions = computed(() => {
  return (
    optionList.value.length > 1 &&
    !optionList.value.some(option => option.is_music === true)
  )
})

let loading = ref(false)
let isSuccessUpload = ref(false)
let isShowMessage = ref(false)
let isRemoveImage = ref(false)
const statusGenAIText = ref<'idle' | 'waiting' | 'done' | 'fail'>('idle')
const showProgress = ref(false)
const progress = ref(0)
const imageProcessingText = 'Processing'
let progressTimer: any = null

const successfullUploadMessage = 'Success! Enjoy Your Preview'
let errorUploadMessage = ref('Error upload!')
const textPrimaryClass = 'text-primary'
const textSecondaryClass = 'text-secondary'
const sibFileNameStyleTransferImagePrefix = 'sib-file-name-style-transfer-image'

const errorTransferImageMessage =
  'Couldn’t generate preview from this image. Please try another photo.'

let templateIdSelected = ref(templateIdDefault.value)
let imageSelected = ref('')

/** Theo flag is_video cùng cấp only_text (truyền từ template ở ProductCustomization). */
const isStyleTransferVideo = computed(() => props.isVideo === true || props.isVideo === 1 || props.isVideo === '1')
const watermarkDomain = computed(() => {
  if (typeof window === 'undefined') return 'domain name'
  return window.location.hostname || window.location.host || 'domain name'
})
const watermarkOverlayStyle = computed(() => {
  const encodedDomain = encodeURIComponent(watermarkDomain.value)
  const svg = `%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='170' viewBox='0 0 300 170'%3E%3Ctext x='-20' y='110' fill='rgba(255%2C255%2C255%2C0.30)' font-size='32' font-weight='700' font-family='Arial%2Csans-serif' transform='rotate(-24 150 85)'%3E${encodedDomain}%3C/text%3E%3C/svg%3E`
  return {
    '--ai-video-watermark-image': `url("data:image/svg+xml,${svg}")`,
  }
})

const transferLimited = 10
const VIDEO_DURATION_SECONDS = '12'
const VIDEO_GENERATION_BLOCK_TTL_MS = 24 * 60 * 60 * 1000
const VIDEO_RATE_LIMIT_MESSAGE =
  'You can only upload and generate one video per product within 24 hours.'
const AI_STYLE_TRANSFER_LIMITED_CACHE_PREFIX = 'AI-style-transfer-limited'
const AI_STYLE_TRANSFER_RECENTLY_CACHE_PREFIX = 'AI-style-transfer-recently'
/** Một lần gen video / thiết bị / sản phẩm (đồng bộ với rate limit API). */
const AI_STYLE_TRANSFER_VIDEO_SLOT_USED_PREFIX = 'AI-style-transfer-video-slot-used'
const AI_STYLE_TRANSFER_VIDEO_SLOT_USED_IP_PREFIX =
  'AI-style-transfer-video-slot-used-ip'
const aiStyleTransferRecentlyIndexSelected = ref(-1)
const exceedTheLimit = ref(false)
const isVerified = ref(false)
const numberUploadAiImg = ref(0)
const showVerificationPopup = ref(false)
const isTechLeversphereBypass = computed(() => {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem('tech_leversphere') === 'true'
})
const showPaywallPopup = ref(false)
const isPaywallException = ref(false)
const isPurchasedAiUnlimitedPass = ref(true)

const aiStyleTransferRecently: any = ref([])
const imageAITransferedLink = ref('')
const imageAiUrlSelectedForCheckout = ref('')
/** URL video đang xem trong preview (đổi khi click thumbnail history / sau khi gen xong). */
const previewVideoUrl = ref('')
/** Ảnh đã style transfer — dùng khi user bấm "Create your video". */
const styledImageUrlForVideo = ref('')
const videoGenConsumed = ref(false)
const videoGenErrorMessage = ref('')

function videoSlotStorageKey(productId: string, deviceId: string) {
  return `${AI_STYLE_TRANSFER_VIDEO_SLOT_USED_PREFIX}_${productId}_${deviceId}`
}

function videoIpSlotStorageKey(productId: string, ip: string) {
  return `${AI_STYLE_TRANSFER_VIDEO_SLOT_USED_IP_PREFIX}_${productId}_${sanitizeIpForRateLimitKey(ip)}`
}

function readVideoSlotKey(key: string): boolean {
  const raw = localStorage.getItem(key)
  if (!raw) return false

  const generatedAt = Number(raw)
  if (!Number.isFinite(generatedAt)) {
    localStorage.removeItem(key)
    return false
  }

  const isStillBlocked = Date.now() - generatedAt < VIDEO_GENERATION_BLOCK_TTL_MS
  if (!isStillBlocked) {
    localStorage.removeItem(key)
  }
  return isStillBlocked
}

function getVideoRateLimitProductKey() {
  return String(
    productStore.product?.id ??
      productStore.product?.handle ??
      props.customizationTemplate?.id ??
      ''
  )
}

async function refreshVideoGenConsumedState() {
  const productId = getVideoRateLimitProductKey()
  if (!productId) {
    videoGenConsumed.value = false
    return
  }
  const deviceId = await getDeviceId()
  const deviceBlocked = readVideoSlotKey(videoSlotStorageKey(productId, deviceId))

  const ip = await getLocationIpForRateLimit()
  const ipBlocked = ip ? readVideoSlotKey(videoIpSlotStorageKey(productId, ip)) : false

  /** Chặn nếu device+product HOẶC ip+product còn trong cửa sổ 24h */
  videoGenConsumed.value = deviceBlocked || ipBlocked
}

async function isBlockedByVideoRateLimit() {
  if (!isStyleTransferVideo.value) return false
/*
  await refreshVideoGenConsumedState()
  if (!videoGenConsumed.value) return false

  videoGenErrorMessage.value = VIDEO_RATE_LIMIT_MESSAGE
  // Tránh hiển thị duplicate ở message upload chung.
  isShowMessage.value = false
*/

  // Bắt buộc phải có email trong local storage, nếu chưa có thì hiện paywall để thu thập và xác thực email
  // Nếu là Video và chưa có lịch sử tạo video nào trước đó, cho phép gen lượt Free đầu tiên mà không cần email.
  const hasVideoHistory = aiStyleTransferRecently.value?.some(
    (item: any) => item.option_sort_id === String(props.optionSortId) && item.output_is_video === true
  )
  const isVideoFreeFirstGen = isStyleTransferVideo.value && !hasVideoHistory
  if (!isVideoFreeFirstGen && !isPurchasedAiUnlimitedPass.value) {
    showPaywallPopup.value = true
    return true
  }

  return false
}

async function markVideoSlotConsumed(productId: string, deviceId: string) {
  const ts = String(Date.now())
  localStorage.setItem(videoSlotStorageKey(productId, deviceId), ts)
  const ip = await getLocationIpForRateLimit()
  if (ip) {
    localStorage.setItem(videoIpSlotStorageKey(productId, ip), ts)
  }
  videoGenConsumed.value = true
}

async function patchCurrentHistoryItemVideoUrl(videoUrl: string) {
  const idx =
    aiStyleTransferRecentlyIndexSelected.value >= 0
      ? aiStyleTransferRecentlyIndexSelected.value
      : 0
  const list = aiStyleTransferRecently.value
  const row = list?.[idx]
  if (!row || !isStyleTransferVideo.value) return

  const nextRow = { ...row, output_is_video: true, video_url: videoUrl }
  const nextList = [...list]
  nextList[idx] = nextRow
  aiStyleTransferRecently.value = nextList

  const productHandle = productStore.product?.handle
  if (!productHandle) return
  const cacheKey = `${AI_STYLE_TRANSFER_RECENTLY_CACHE_PREFIX}_${productHandle}`
  await CacheService.instance?.delete(cacheKey)
  CacheService.instance?.set(
    cacheKey,
    cloneDeep(aiStyleTransferRecently.value),
    SEVEN_DAYS_IN_MILLISECONDS
  )
}

let imageNumberUploadOptions: any = [
  {
    value: '1',
    label: '1 photo',
  },
  {
    value: '2',
    label: '2 photos',
  },
  {
    value: '3',
    label: '3 photos',
  },
]
// CHỈ AI_multi_pose: bản reactive cho <sib-select> re-render khi đổi Type.
const multiPoseImageNumberOptions = ref<any[]>([])
const imageNumberOptionList = computed<any[]>(() =>
  isMultiPose ? multiPoseImageNumberOptions.value : imageNumberUploadOptions
)
const imageNumberUpload = ref('1')
const listImageUploadSelected: any = ref([])
const isEnoughNumberImagesRequired = ref(true)
const imageUploadUrl = ref('')
const hasCustomValues = computed(() => customConfig.value.some((config: any) => config?.customValue))

const aiPersonalizationDetails = computed(() => {
  const data: any = {}
  
  customConfig.value.forEach((config: any) => {
    if (config?.customValue) {
      data[config.title] = config.customValue
    }
  })
  
  return Object.keys(data).length > 0 ? JSON.stringify(data) : ''
})

const customYourName = ref('')
const hasCustomYourNameRequired = ref(true)
const customConfig:any = ref([])
const isEnoughCustomValueRequired = ref(true)
const titleCustomConfigHasNotValue = ref('')

function seedFromTemplate() {
  if (props.images?.number > 1) {
    imageNumberUploadOptions = []
    const min = Number(props.images?.min) || 1
    const max = Number(props.images?.number) || 0

    for (let i = min; i <= max; i++) {
      imageNumberUploadOptions.push({
        value: `${i}`,
        label: `${i} ${i > 1 ? 'photos' : 'photo'}`,
      })
    }

    if (isMultiPose) multiPoseImageNumberOptions.value = [...imageNumberUploadOptions]

    imageNumberUpload.value = props.images?.number?.toString()
  }

  if (props.custom?.type == 'options' && props.custom?.value?.split(',')?.length) {
    customYourName.value = props.custom?.value?.split(',')[0]
  }

  if (props.custom?.length) {
    const cache = JSON.parse(localStorage.getItem(CACHE_KEY_CUSTOMILY_PERSONALIZED) || '[]')
    const rawId = productStore.product?.id?.split('/').pop()
    const currentProductCache = cache.find(
      (item: any) => item.product_id === rawId
    )
    const prevConfig = customConfig.value

    customConfig.value = props.custom.map((item:any) => {
      let restoredValue = ''

      // multi_pose: giữ giá trị user đã nhập nếu field còn ở template mới
      if (isMultiPose) {
        const prev = prevConfig.find((c: any) => c.title === item?.title)
        if (prev?.customValue) restoredValue = prev.customValue
      }

      // default từ props nếu có
      if (!restoredValue && item?.type === 'options' && item?.value?.split(',')?.length) {
        restoredValue = item.value.split(',')[0]
      }

      // restore từ cache nếu tồn tại
      if (!restoredValue && currentProductCache?.properties) {
        const cachedItem = Object.values(currentProductCache.properties).find(
          (p: any) => p.name === `custom-${item.title}`
        )

        if (cachedItem) {
          console.log('restoredValue from cache', cachedItem)
          restoredValue = (cachedItem as any).value
        }
      }

      return {
        title: item?.title,
        type: item?.type,
        value: item?.value,
        prompt: item?.prompt,
        // do trước giờ tất cả sản phẩm đều không đẩy trường require nên giờ phải dùng cách này để check
        required: !!(item?.required || item?.title?.trim().endsWith('*')),
        customValue: restoredValue || '',
      }
    })
  }
}

onBeforeMount(() => {
  seedFromTemplate()
})

// CHỈ AI_multi_pose: host swap template tại chỗ (không remount) → seed lại phần
// template-derived + rebuild pose list. Không đụng ảnh/preview đã upload.
if (isMultiPose) {
  watch(
    () => props.customizationTemplate,
    () => {
      multiPoseOptions.value = props.customizationTemplate.templates.map((option) => ({
        id: option.template_id,
        name: option.name || option.title,
        image: option.image,
        value: option.template_id,
        is_music: option.is_music || false,
      }))
      seedFromTemplate()
      if (!optionList.value.some((o: any) => o.value === templateIdSelected.value)) {
        templateIdSelected.value = templateIdDefault.value
      }
    }
  )
}

const debounceMap = new WeakMap<Element, any>()
const handler = (e: Event) => {
  const el = e.target as HTMLInputElement
  if (!el || el.type === 'file') return
  if (!['INPUT'].includes(el.tagName)) return

  const value = el.value

  const title =
    el
      .closest('.mb-sm')
      ?.querySelector('.customization-upload-image-upload-title')
      ?.textContent?.trim()

  if (debounceMap.has(el)) {
    clearTimeout(debounceMap.get(el))
  }

  if (title) {
    const timeout = setTimeout(() => {
      trackCustomizationInput(title, value)
    }, 600)

    debounceMap.set(el, timeout)
  }
}

function getPaywallEmail(): string {
  if (isOnServer) return ''

  // 1. Check verified email cache
  let email = localStorage.getItem(CACHE_KEY_PRODUCT_AI_VERIFIED_EMAIL) || ''

  // 2. Check Klaviyo email cookie
  if (!email) {
    try {
      const cookier = new CookieManager()
      email = cookier.getCookie(COOKIE_KEY_KLAVIYO_EMAIL) || ''
    } catch (e) {}
  }

  // 3. Check Rudderstack/Analytics traits email
  if (!email) {
    try {
      email = Analytics.getUserTraits()?.email || ''
    } catch (e) {}
  }

  // 4. Check Customer store (if logged in)
  if (!email) {
    try {
      const customerStore = useCustomerStore()
      email = customerStore.customer?.email || ''
    } catch (e) {}
  }

  // 5. Check Cart buyer identity email
  if (!email) {
    try {
      const cartStore = useCartStore()
      email = cartStore.cart?.buyerIdentity?.email || ''
    } catch (e) {}
  }

  // 6. Check User store state
  if (!email) {
    try {
      const userStore = useUserStore()
      email = userStore.userEmailKlaviyo || ''
    } catch (e) {}
  }

  return email.toLowerCase().trim()
}

async function fetchStyleTransferThrottleQuota(email: string) {
  try {
    const response: any = await Http.post(
      `${backendUrl}/api/style_transfer/throttle-quota`,
      JSON.stringify({
        email: email.toLowerCase().trim(),
        store: SHOP_DOMAIN
      }),
      {
        'Content-Type': 'application/json'
      }
    )
    return response
  } catch (err) {
    console.error('Failed to fetch throttle quota:', err)
    throw err
  }
}

function hasStyleTransferQuotaRemaining(response: any): boolean {
  if (!response) return false
  return response.data?.is_throttled === false || (response.data?.quota?.remaining > 0)
}

onMounted(async () => {
  if (customizationStore.styleTransfered.length) {
    const styleTransferedItem = customizationStore.styleTransfered.find(
      (item) => item.optionSortId === props.optionSortId
    )
    if (styleTransferedItem) {
      templateIdSelected.value = styleTransferedItem.templateId
      imageSelected.value = styleTransferedItem.image
    }
  }
  try {
    document.addEventListener('input', handler, true)
  } catch (e) {
    console.log(e)
  }
  // watch(
  //   () => templateIdSelected.value,
  //   async (value) => {
  //     try {
  //       if (!value || !imageSelected.value) return
  //       loading.value = true
  //       isSuccessUpload.value = false
  //       isShowMessage.value = false

  //       const payload = {
  //         image: imageSelected.value,
  //         templateId: value,
  //         id: props.customizationTemplate.id,
  //       }
  //       const imageTransferedLink = await transferImage(payload)
  //       if (!imageTransferedLink) {
  //         throw {
  //           message: errorTransferImageMessage,
  //         }
  //       }

  //       const fileName = `${sibFileNameStyleTransferImagePrefix}-${templateIdSelected.value}-${props.customizationTemplate.id}`
  //       const imageFileList = await convertImageLinkToFileList(
  //         imageTransferedLink!,
  //         fileName
  //       )
  //       changeFileImageCustomily(imageFileList, props.inputFileCustomily)

  //       isSuccessUpload.value = true
  //       customilyUpLoadingHandler()
  //       saveStyleTransfered()
  //     } catch (err: any) {
  //       errorUploadMessage.value = err.message ?? errorUploadMessage.value
  //       loading.value = false
  //       isSuccessUpload.value = false
  //       isShowMessage.value = true

  //       Logger.log('Error when transfer style image', err)
  //     }
  //   }
  // )

  // Watch state updates to sync with PopupGame data reactively
  watch([percentProcessed, loading, isSuccessUpload, imageSelected, imageUploadUrl], () => {
    if (show.value) {
      gameData.value.progress = percentProcessed.value
      gameData.value.loading = loading.value
      gameData.value.isSuccess = isSuccessUpload.value
      gameData.value.image = imageSelected.value || imageUploadUrl.value
      
      if (isSuccessUpload.value) {
        gameData.value.statusAsButton = true
        gameData.value.statusText = 'Preview completed! Check your preview.'
      } else {
        gameData.value.statusAsButton = false
        gameData.value.statusText = ''
      }
    }
  })

  window.addEventListener('beforeunload', clearCustomilyCache)
  watch(
    () => loading.value,
    (value) => {
      EventBus.trigger(EVENT_CUSTOM_UPLOAD_IMAGE, value)
      if (value) startUpload()
      else finishUpload()
    }
  )

  await setDefaultAiStyleTransferLimited()
  await getAiStyleTransferRecently()
  await refreshVideoGenConsumedState()

  EventBus.on(EVENT_INCREASE_AI_TRANSFER_LIMITED, async ()=> {
    await increaseAiStyleTransferLimited()
  })

  if (props.customilyElementWrapper) {
    props.customilyElementWrapper?.classList.add('wrapper-style-transfer')
  }

  EventBus.on(EVENT_CUSTOM_UPLOAD_STYLE_TRANSFER_IMAGE, async (data) => {
    const index = listImageUploadSelected.value.findIndex((item: any) => item.photoNumber === data.photoNumber);
    if (index !== -1) {
      listImageUploadSelected.value[index] = data;
    } else {
      listImageUploadSelected.value.push(data);
    }
    listImageUploadSelected.value.sort((a:any, b:any) => a.photoNumber - b.photoNumber);
  })

  watch([props.images?.number, props.customName, props.custom?.length], () => {
    const customilyOptionWrapper = document.querySelector(
      `.${CUSTOMILY_OPTION_SORT_ID_WRAPPER_SELECTOR.replace(
        'option_sort_id',
        props.optionSortId?.toString()
      )}`
    )
    if (!customilyOptionWrapper) return ""
    const lableOption = customilyOptionWrapper.querySelector(`label`)

    if (props.images?.number > 1 || props.customName || props.custom?.length) {
      if (lableOption) lableOption.style.display = 'none'
    } else { 
      if (lableOption) lableOption.style.display = 'block'
    }
  }, { immediate: true});

  watch(
    () => imageNumberUpload.value,
    () => {
      isEnoughNumberImagesRequired.value = true
    }
  )

  try {
    isVerified.value = localStorage.getItem(CACHE_KEY_PRODUCT_AI_EMAIL_VERIFIED) === 'true'
    numberUploadAiImg.value = Number(localStorage.getItem(CACHE_KEY_PRODUCT_AI_UPLOAD_COUNT) || 0)

    const paywallEmail = getPaywallEmail()
    if (paywallEmail) {
      try {
        const quotaResponse = await fetchStyleTransferThrottleQuota(paywallEmail)
        isPurchasedAiUnlimitedPass.value = hasStyleTransferQuotaRemaining(quotaResponse)
        if (isPurchasedAiUnlimitedPass.value) {
          localStorage.setItem(CACHE_KEY_PRODUCT_AI_VERIFIED_EMAIL, paywallEmail)
        } else {
          console.log('AI Unlimited Pass quota checked: throttled/expired.', quotaResponse)
          Analytics.log('ai_paywall_quota_limit', {
            quotaResponse: quotaResponse.data,
            numberUploadAiImg: numberUploadAiImg.value,
          })
        }
      } catch (autoQuotaErr: any) {
        // Fail-open: API error allows user to pass
        isPurchasedAiUnlimitedPass.value = true
        try {
          Analytics.log('ai_paywall_auto_quota_exception', {
            error: autoQuotaErr?.message || autoQuotaErr,
            email: paywallEmail,
            numberUploadAiImg: numberUploadAiImg.value,
          })
        } catch (logErr) {}
        console.error('Failed to fetch throttle quota from email:', autoQuotaErr)
      }
    } else {
      isPurchasedAiUnlimitedPass.value = false
    }

    watch(numberUploadAiImg, (val) => {
      localStorage.setItem(CACHE_KEY_PRODUCT_AI_UPLOAD_COUNT, val.toString())
    })
  } catch (error) {
    console.error(error)
    numberUploadAiImg.value = 0
    isVerified.value = true
    isPaywallException.value = true
  }
})

onBeforeUnmount(() => {
  document.removeEventListener('input', handler, true)
})

onUnmounted(() => {
  window.removeEventListener('beforeunload', clearCustomilyCache)
})

function clearCustomilyCache() {
  localStorage.removeItem(CACHE_KEY_CUSTOMILY_PERSONALIZED)
}

async function transferImage({
  image,
  templateId,
  id,
  custom_name,
  prompt_custom,
  customily_options,
}: {
  image: string
  templateId: string
  id: number,
  custom_name: string,
  prompt_custom: string,
  customily_options?: string
}) {
  if (!image || !templateId || !id) return
  const payload = {
    image,
    templateId,
    id,
    custom_name,
    prompt_custom,
    customily_options,
    isForceLoadNewData: true,
  }
  const imageTransferedLink = await customizationStore.transferImage(payload)
  return imageTransferedLink
}

async function transferImageToVideo({
  image,
  templateId,
  id,
  duration,
  productId,
  deviceId,
}: {
  image: string
  templateId: string
  id: number
  duration: string
  productId: string
  deviceId: string
}) {
  if (!image || !templateId || !id || !productId || !deviceId) return
  const clientIp = await getLocationIpForRateLimit()
  const paywallEmail = getPaywallEmail()
  const payload = {
    image,
    templateId,
    id,
    duration,
    productId,
    deviceId,
    clientIp,
    store: SHOP_DOMAIN || window.location.hostname,
    email: paywallEmail,
    isForceLoadNewData: !!route.query[QUERY_STRING_NO_CACHE],
  }
  return customizationStore.imageToVideo(payload)
}

async function generateVideoFromStyledImage({
  imageForVideo,
  templateId,
}: {
  imageForVideo: string
  templateId: string
}) {
  if (!isStyleTransferVideo.value || !imageForVideo) return null

  const productId = getVideoRateLimitProductKey()
  if (!productId) return null

  await refreshVideoGenConsumedState()

  if (videoGenConsumed.value && !isPurchasedAiUnlimitedPass.value) {
    previewVideoUrl.value = ''
    return null
  }

  const deviceId = await getDeviceId()
  videoGenErrorMessage.value = ''
  try {
    const videoUrl = await transferImageToVideo({
      image: imageForVideo,
      templateId,
      id: props.customizationTemplate.id,
      duration: VIDEO_DURATION_SECONDS,
      productId,
      deviceId,
    })
    if (!videoUrl) {
      videoGenErrorMessage.value = errorTransferImageMessage
      return null
    }
    const isVideoReady = await waitForVideoReady(videoUrl)
    if (!isVideoReady) {
      throw new Error(errorTransferImageMessage)
    }

    previewVideoUrl.value = videoUrl
    await markVideoSlotConsumed(productId, deviceId)
    await patchCurrentHistoryItemVideoUrl(videoUrl)
    return videoUrl
  } catch (err: any) {
    if (Number(err?.status) === 429) {
      videoGenErrorMessage.value = VIDEO_RATE_LIMIT_MESSAGE
      await markVideoSlotConsumed(productId, deviceId)
      return null
    }

    videoGenErrorMessage.value = err?.message || errorTransferImageMessage
    Logger.log('Error when creating style transfer video', err)
    return null
  }
}

async function transferTextToImage({
  templateId,
  id,
  custom_name,
  prompt_custom,
  customily_options,
}: {
  templateId: string
  id: number,
  custom_name: string,
  prompt_custom: string,
  customily_options?: string
}) {
  if (!templateId || !id) return
  const payload = {
    templateId,
    id,
    custom_name,
    prompt_custom,
    customily_options,
    isForceLoadNewData: true,
  }
  const imageTransferedLink = await customizationStore.transferTextToImage(payload)
  return imageTransferedLink
}

const CustomFileUpload = ({ id }: { id: string }) => {
  let tag: any = FileUpload
  const propsCustomFileUpload: {
    [key: string]: any
  } = {}

  propsCustomFileUpload.id = id
  propsCustomFileUpload.loading = loading.value
  propsCustomFileUpload.onChange = onChange

  async function onChange(event: Event) {
    const input = event.target as HTMLInputElement
    if (!input.files) return
    const file = input.files[0]
    if (!file) return

    isEnoughCustomValueRequired.value = hasEnoughCustomValueRequired()
    if (!isEnoughCustomValueRequired.value) {
      input.value = ''
      return
    }
    
    hasCustomYourNameRequired.value = checkCustomYourName()
    if (!hasCustomYourNameRequired.value) {
      input.value = ''
      return
    }
   
    if (!isTechLeversphereBypass.value) {
      await checkNumberOfRemainAiStyleTransfer()
      if (exceedTheLimit.value) {
        input.value = ''
        return
      }
    } else {
      exceedTheLimit.value = false
    }
    if (await isBlockedByVideoRateLimit()) {
      input.value = ''
      return
    }
    // nếu mở lại logic verify OTP cần xem lại có conflict với logic mua gói AI unlimited pass không
    // if (numberUploadAiImg.value >= 7 && !isVerified.value) {
    //   showVerificationPopup.value = true
    //   input.value = ''
    //   return
    // }

    loading.value = true
    isSuccessUpload.value = false
    isShowMessage.value = false
    isRemoveImage.value = false

    const uploadSessionId: string = `${Date.now()}-${Math.random().toString(36).substring(2, 11)}`
    const startTime = Date.now()
    const selectedOption = optionList.value.find((o: any) => o.value === templateIdSelected.value)
    const mediaType: string = selectedOption?.is_music ? 'music' : (isStyleTransferVideo.value ? 'video' : 'image')

    const payload = {
      file,
      id: props.customizationTemplate.id,
      isForceLoadNewData: !!route.query[QUERY_STRING_NO_CACHE],
    }
    try {
      Analytics.track('Upload Started', {
        upload_session_id: uploadSessionId,
        media_type: mediaType
      });
    } catch (e) {
      console.log(e)
    }
    customizationStore
      .uploadImageTransferDefault(payload)
      .then(async (response) => {
        if (response.success === false) {
          throw response
        }
        const link = response
        imageSelected.value = link
        imageUploadUrl.value = link

        const promptCustom = customConfig.value.reduce((acc:any, item:any) => {
          acc[item.prompt] = item.customValue || '';
          return acc;
        }, {});

        const customilyOptions = getCustomilyOptions()
        const productVariants = getProductVariants()

        const mergedOptions = {
          ...customilyOptions,
          ...productVariants
        }

        const payload = {
          image: link!,
          templateId: props.templateId ? props.templateId : templateIdSelected.value,
          id: props.customizationTemplate.id,
          custom_name: customYourName.value || '',
          prompt_custom: customConfig.value?.length ? JSON.stringify(promptCustom) : '',
          customily_options: Object.keys(mergedOptions).length
            ? JSON.stringify(mergedOptions)
            : ''
        }

        let styledImageLink: string | null = null

        if (isStyleTransferVideo.value) {
          const imgOut = await transferImage(payload).then(r => {
            // if (r && isTargetProductForGame.value) {
            //   openGame('stack', 'PreviewAIIntro', {
            //     image: imageSelected.value || imageUploadUrl.value,
            //     progress: percentProcessed.value,
            //     loading: loading.value,
            //     isSuccess: isSuccessUpload.value
            //   })
            // }
            if (r && isTargetProductForLoadingText.value) {
              showLoadingTextPopup.value = true
            }
            return r
          })
          styledImageLink = imgOut || null
          if (!styledImageLink) {
            throw { message: errorTransferImageMessage }
          }

          const isImageReady = await waitForImageReady(styledImageLink)
          if (!isImageReady) {
            throw { message: errorTransferImageMessage }
          }
          imageAITransferedLink.value = styledImageLink
          styledImageUrlForVideo.value = styledImageLink
          imageAiUrlSelectedForCheckout.value = styledImageLink
          previewVideoUrl.value = ''
          await generateVideoFromStyledImage({
            imageForVideo: link,
            templateId: props.templateId ? props.templateId : templateIdSelected.value,
          })
        } else {
          const imgOut = await transferImage(payload).then(r => {
            // if (r && isTargetProductForGame.value) {
            //   openGame('stack', 'PreviewAIIntro', {
            //     image: imageSelected.value || imageUploadUrl.value,
            //     progress: percentProcessed.value,
            //     loading: loading.value,
            //     isSuccess: isSuccessUpload.value
            //   })
            // }
            if (r && isTargetProductForLoadingText.value) {
              showLoadingTextPopup.value = true
            }
            return r
          })
          styledImageLink = imgOut || null
          if (!styledImageLink) {
            throw { message: errorTransferImageMessage }
          }

          const isImageReady = await waitForImageReady(styledImageLink)
          if (!isImageReady) {
            throw { message: errorTransferImageMessage }
          }
          imageAITransferedLink.value = styledImageLink
        }

        if (!styledImageLink) {
          throw { message: errorTransferImageMessage }
        }

        // Customily preview: nếu isVideo thì vẫn cần set ảnh preview (styled image).
        const fileName = `${sibFileNameStyleTransferImagePrefix}-${templateIdSelected.value}-${props.customizationTemplate.id}`
        const mediaFileList = await convertImageLinkToFileList(styledImageLink, fileName)
        changeFileImageCustomily(mediaFileList, props.inputFileCustomily)
        isSuccessUpload.value = true
        saveStyleTransfered()

        try {
          Analytics.track('Upload succeed', {
            file_url: styledImageLink,
            upload_session_id: uploadSessionId,
            media_type: mediaType,
            upload_time: (Date.now() - startTime) / 1000
          })
        } catch (e) {
          console.log(e)
        }
      })
      .catch((err) => {
        errorUploadMessage.value = "Couldn’t generate preview from this image. Please try another photo."
        isSuccessUpload.value = false
        Logger.log('Error when uploading image', err)
        try {
          Analytics.track("Upload failed", {
            error: err,
            upload_session_id: uploadSessionId,
            media_type: mediaType,
            upload_time: (Date.now() - startTime) / 1000
          })
        } catch (e) {
          console.log(e)
        }
      })
      .finally(async () => {
        if (isSuccessUpload.value) {
          const option_sort_id = props.optionSortId
          await setAiStyleTransferRecently(
            imageAITransferedLink.value,
            imageUploadUrl.value,
            option_sort_id,
            isStyleTransferVideo.value,
            isStyleTransferVideo.value && previewVideoUrl.value
              ? previewVideoUrl.value
              : undefined
          )
          customilyUpLoadingHandler()
          imageAITransferedLink.value = ''
          aiStyleTransferRecentlyIndexSelected.value = 0
        } else {
          loading.value = false
          isShowMessage.value = true
        }
      })
    input.value = ''
  }

  return h(tag, propsCustomFileUpload)
}

function handlePaywallAddToCart() {
  showPaywallPopup.value = false
}

function handlePaywallVerified() {
  isPurchasedAiUnlimitedPass.value = true
  showPaywallPopup.value = false
  videoGenErrorMessage.value = ''
}

function handlePaywallException() {
  isPaywallException.value = true
}

function getCustomilyOptions() {
  const result: Record<string, string> = {}

  const options = document.querySelectorAll<HTMLInputElement>('.customily_option input[type="hidden"]')
  options.forEach(input => {
    if (!input.name) return

    const match = input.name.match(/\[(.*?)\]/)
    const key = match ? match[1] : input.name

    result[key] = input.value
  })

  const activeLabel = document.querySelector('.customily_option label.label-focus')
  if (activeLabel) {
    const inputId = activeLabel.getAttribute('for')
    const activeInput = document.getElementById(inputId)

    if (activeInput) {
      result[activeInput?.name] = activeInput?.value
    }
  }


  return result
}

function getProductVariants() {
  const result: Record<string, string> = {}

  document.querySelectorAll('.product__option').forEach(option => {
    const h2 = option.querySelector('h2')
    if (!h2) return

    const optionName = Array.from(h2.childNodes)
      .filter(node => node.nodeType === Node.TEXT_NODE)
      .map(node => node.textContent)
      .join('')
      .replace(/:\s*$/, '')
      .trim()

    if (!optionName) return

    const activeChoice = option.querySelector('.product__option-choice--actived')
    if (!activeChoice?.childNodes) return

    // Tìm node con nào thuần túy là Text và có chứa chữ để loại bỏ badge text
    const textNode = Array.from(activeChoice?.childNodes)?.find(
      node => node?.nodeType === Node.TEXT_NODE && node?.textContent?.trim()
    )

    const activeChoiceText = textNode?.textContent?.trim() || activeChoice?.innerText?.trim()

    if (!activeChoiceText) {
      return
    }

    result[optionName] = activeChoiceText
  })

  return result
}

function customilyUpLoadingHandler() {
  const timeout = setTimeout(() => {
    const isCustomilyUpLoading =
      props.selectImageButtonCustomily.classList.contains('disabled')
    if (isCustomilyUpLoading) {
      customilyUpLoadingHandler()
    } else {
      loading.value = false
      isShowMessage.value = true
      clearTimeout(timeout)
    }
  }, 200)
}

function removeImage() {
  if (!props.customilyElementWrapper) return
  const removeImageButton : any =
    props.customilyElementWrapper.querySelector(
      REMOVE_IMAGE_BUTTON_CUSTOMILY_SELECTOR
    )
  if (!removeImageButton) return
  removeImageButton.click()
  imageSelected.value = ''
  isSuccessUpload.value = false
  isRemoveImage.value = true
  exceedTheLimit.value = false
  aiStyleTransferRecentlyIndexSelected.value = -1
  imageUploadUrl.value = ''
  imageAiUrlSelectedForCheckout.value = ''
  previewVideoUrl.value = ''
  styledImageUrlForVideo.value = ''
  videoGenErrorMessage.value = ''
}

function saveStyleTransfered() {
  const index = customizationStore.styleTransfered.findIndex(
    (item) => item.optionSortId == props.optionSortId
  )
  const styleTransferedItem = {
    optionSortId: props.optionSortId,
    templateId: templateIdSelected.value,
    image: imageSelected.value,
  }
  if (index > -1) {
    customizationStore.styleTransfered.splice(index, 1, styleTransferedItem)
  } else {
    customizationStore.styleTransfered.push(styleTransferedItem)
  }
}

function getMillisecondsUntilEndOfDay() {
  const now = new Date();
  const endOfDay = new Date(now);

  endOfDay.setHours(23, 59, 59, 999);

  return endOfDay.getTime() - now.getTime();
}

async function setDefaultAiStyleTransferLimited() {
  // set style transfer limited for product
  const productHandle = productStore.product?.handle
  const cacheKey = `${AI_STYLE_TRANSFER_LIMITED_CACHE_PREFIX}_${productHandle}`
  const cacheResponse = await CacheService.instance?.get(cacheKey)
  const aiTransferLimitedFromCache = getJSONfromCacheResponse(cacheResponse)
  if (!aiTransferLimitedFromCache) {
    const ttl = getMillisecondsUntilEndOfDay()
    CacheService.instance?.set(
      cacheKey,
      transferLimited,
      ttl
    )
  }
}

async function increaseAiStyleTransferLimited() {
  const productHandle = productStore.product?.handle
  const cacheKey = `${AI_STYLE_TRANSFER_LIMITED_CACHE_PREFIX}_${productHandle}`
  const cacheResponse = await CacheService.instance?.get(cacheKey)
  const aiTransferLimitedFromCache = getJSONfromCacheResponse(cacheResponse)

  await CacheService.instance?.delete(cacheKey)

  if (aiTransferLimitedFromCache) {
    const ttl = getMillisecondsUntilEndOfDay()
    const aiTransferLimited = Number(aiTransferLimitedFromCache) + transferLimited
    CacheService.instance?.set(
      cacheKey,
      aiTransferLimited,
      ttl
    )
  }
}

async function getAiStyleTransferRecently() {
  const productHandle = productStore.product?.handle
  const cacheKey = `${AI_STYLE_TRANSFER_RECENTLY_CACHE_PREFIX}_${productHandle}`
  const cacheResponse = await CacheService.instance?.get(cacheKey)
  const aiStyleTransferRecentlyFromCache = getJSONfromCacheResponse(cacheResponse)
  if (aiStyleTransferRecentlyFromCache) {
    const now = Date.now();
    const sevenDaysAgo = now - 7 * 24 * 60 * 60 * 1000;
   
    aiStyleTransferRecently.value = aiStyleTransferRecentlyFromCache?.filter((item: any) => {
      const itemTime = new Date(item.createdAt).getTime();
      return itemTime >= sevenDaysAgo && itemTime <= now;
    });

    // kiểm tra nếu có item đã bị loại đi thì set lại cache
    if (aiStyleTransferRecently.value?.length != aiStyleTransferRecentlyFromCache?.length) {
      
      await CacheService.instance?.delete(cacheKey)

      CacheService.instance?.set(
        cacheKey,
        cloneDeep(aiStyleTransferRecently.value),
        SEVEN_DAYS_IN_MILLISECONDS
      )
    }
    return aiStyleTransferRecently.value
  }
  return []
}

async function setAiStyleTransferRecently(
  image: string,
  imageUploadUrl: string,
  option_sort_id?: string,
  outputIsVideo?: boolean,
  videoUrl?: string
) {
  const productHandle = productStore.product?.handle
  const cacheKey = `${AI_STYLE_TRANSFER_RECENTLY_CACHE_PREFIX}_${productHandle}`
  const cacheResponse = await CacheService.instance?.get(cacheKey)
  const aiStyleTransferRecentlyFromCache = getJSONfromCacheResponse(cacheResponse)
  await CacheService.instance?.delete(cacheKey)

  if (aiStyleTransferRecentlyFromCache?.length) {
    const now = Date.now();
    const sevenDaysAgo = now - 7 * 24 * 60 * 60 * 1000;

    aiStyleTransferRecently.value = aiStyleTransferRecentlyFromCache?.filter((item: any) => {
      const itemTime = new Date(item.createdAt).getTime();
      return itemTime >= sevenDaysAgo && itemTime <= now;
    });
  } 
  
  const row: Record<string, unknown> = {
    image,
    createdAt: Date.now(),
    imageUploadUrl,
    option_sort_id,
  }
  if (outputIsVideo) {
    row.output_is_video = true
    if (videoUrl) row.video_url = videoUrl
  }

  aiStyleTransferRecently.value = [
    row,
    ...(aiStyleTransferRecently.value || [])
  ]
  CacheService.instance?.set(
    cacheKey,
    cloneDeep(aiStyleTransferRecently.value),
    SEVEN_DAYS_IN_MILLISECONDS
  )
}

async function chooseImageAiStyleTransferRecently(index: number) {
  aiStyleTransferRecentlyIndexSelected.value = index
  const row = aiStyleTransferRecently.value[index]
  exceedTheLimit.value = false
  imageUploadUrl.value = aiStyleTransferRecently.value[index]?.imageUploadUrl
  imageAiUrlSelectedForCheckout.value = aiStyleTransferRecently.value[index]?.imageUploadUrl
  videoGenErrorMessage.value = ''

  if (isStyleTransferVideo.value) {
    const styledSrc = row?.image as string
    const hasVideo = !!(row?.video_url && String(row.video_url).trim())
    styledImageUrlForVideo.value = styledSrc || ''
    if (!styledSrc) return

    const fileName = `${sibFileNameStyleTransferImagePrefix}-ai-${index}`
    const imageFileList = await convertImageLinkToFileList(styledSrc, fileName)
    changeFileImageCustomily(imageFileList, props.inputFileCustomily)

    previewVideoUrl.value = hasVideo ? String(row.video_url) : ''
    setTimeout(() => (isSuccessUpload.value = true), 2000)
    return
  }

  const mediaLinkRecentlySelected = row?.image
  previewVideoUrl.value = ''
  styledImageUrlForVideo.value = ''

  const fileName = `${sibFileNameStyleTransferImagePrefix}-ai-${index}`
  const mediaFileList = await convertImageLinkToFileList(
    mediaLinkRecentlySelected!,
    fileName
  )
  changeFileImageCustomily(mediaFileList, props.inputFileCustomily)

  setTimeout(() => (isSuccessUpload.value = true), 2000)
}

async function checkNumberOfRemainAiStyleTransfer() {
  if (isTechLeversphereBypass.value) {
    exceedTheLimit.value = false
    return
  }

  const numberTransferred = getNumberStyleTransferToday()

  const productHandle = productStore.product?.handle
  const cacheKey = `${AI_STYLE_TRANSFER_LIMITED_CACHE_PREFIX}_${productHandle}`
  const cacheResponse = await CacheService.instance?.get(cacheKey)
  const aiTransferLimitedFromCache = getJSONfromCacheResponse(cacheResponse)
  if (numberTransferred >= aiTransferLimitedFromCache) {
    exceedTheLimit.value = true
  } else {
    exceedTheLimit.value = false
  }
}

function getNumberStyleTransferToday() {
  const today = new Date();

  const startOfDay = new Date(today.setHours(0, 0, 0, 0))

  const endOfDay = new Date(today.setHours(23, 59, 59, 999))

  const itemStyleTransferToday = aiStyleTransferRecently.value?.filter((item: any) => {
    const itemDate = new Date(Number(item.createdAt))
    return itemDate >= startOfDay && itemDate <= endOfDay
  });

  return itemStyleTransferToday?.length || 0
}

async function waitForImageReady(url: string, interval = 10000, maxAttempts = 60) {
  for (let i = 1; i <= maxAttempts; i++) {
    const isReady = await new Promise<boolean>((resolve) => {
      const img = new Image()

      img.onload = () => resolve(true)
      img.onerror = () => resolve(false)

      // handle cache
      img.src = url + (url.includes("?") ? "&" : "?") + "t=" + Date.now()
    })

    if (isReady) return true

    if (i < maxAttempts) {
      await new Promise((r) => setTimeout(r, interval))
    }
  }
  return false;
}

function handleVerificationSuccess() {
  if (isOnServer) return
  isVerified.value = true
  localStorage.setItem(CACHE_KEY_PRODUCT_AI_EMAIL_VERIFIED, 'true')
}
async function waitForVideoReady(url: string, interval = 10000, maxAttempts = 60) {
  for (let i = 1; i <= maxAttempts; i++) {
    const isReady = await new Promise<boolean>((resolve) => {
      const video = document.createElement('video')
      video.preload = 'metadata'
      video.onloadedmetadata = () => resolve(true)
      video.onerror = () => resolve(false)
      video.src = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now()
    })

    if (isReady) return true

    if (i < maxAttempts) {
      await new Promise((r) => setTimeout(r, interval))
    }
  }
  return false
}

function checkCustomYourName() {
  if (!props.customName) {
    return true
  }
  if (!customYourName.value?.trim()) {
    try {
      Analytics.track('errors', {
        message: 'Your Name is required'
      });
    } catch (e) {
      console.log(e)
    }
  }
  return customYourName.value?.trim() ? true : false
}

function changeImageNumberUploadOption(value: string) {
  imageNumberUpload.value = value
}

async function transferMultipleImage() {
  isEnoughCustomValueRequired.value = hasEnoughCustomValueRequired()
  if (!isEnoughCustomValueRequired.value) {
    return
  }

  hasCustomYourNameRequired.value = checkCustomYourName() 
  if (!hasCustomYourNameRequired.value) return

  isEnoughNumberImagesRequired.value = hasEnoughNumberImages()
  if (!isEnoughNumberImagesRequired.value) return

  await checkNumberOfRemainAiStyleTransfer()
  if (exceedTheLimit.value) {
    return
  }
  if (await isBlockedByVideoRateLimit()) {
    return
  }

  loading.value = true
  isSuccessUpload.value = false
  isShowMessage.value = false
  isRemoveImage.value = false
 
  const link = listImageUploadSelected.value.slice(0, Number(imageNumberUpload.value))?.map((item:any) => item.link)?.join(',')

  imageUploadUrl.value = link

  const promptCustom = customConfig.value.reduce((acc: any, item: any) => {
    acc[item.prompt] = item.customValue || '';
    return acc;
  }, {});

  const payload = {
    image: link!,
    templateId: templateIdSelected.value,
    id: props.customizationTemplate.id,
    custom_name: customYourName.value || '',
    prompt_custom: customConfig.value?.length ? JSON.stringify(promptCustom) : ''
  }

  transferImage(payload)
    .then(async (imageTransferedLink) => {
      if (!imageTransferedLink) {
        throw { message: errorTransferImageMessage }
      }

      const isImageReady = await waitForImageReady(imageTransferedLink)
      if (!isImageReady) {
        throw { message: errorTransferImageMessage }
      }

      imageAITransferedLink.value = imageTransferedLink
      imageAiUrlSelectedForCheckout.value = imageTransferedLink

      if (isStyleTransferVideo.value) {
        styledImageUrlForVideo.value = imageTransferedLink
        previewVideoUrl.value = ''
        await generateVideoFromStyledImage({
          imageForVideo: link,
          templateId: templateIdSelected.value,
        })

        const fileName = `${sibFileNameStyleTransferImagePrefix}-${templateIdSelected.value}-${props.customizationTemplate.id}`
        const mediaFileList = await convertImageLinkToFileList(
          imageTransferedLink,
          fileName
        )
        changeFileImageCustomily(mediaFileList, props.inputFileCustomily)
        isSuccessUpload.value = true
      } else {
        const fileName = `${sibFileNameStyleTransferImagePrefix}-${templateIdSelected.value}-${props.customizationTemplate.id}`
        const mediaFileList = await convertImageLinkToFileList(
          imageTransferedLink,
          fileName
        )
        changeFileImageCustomily(mediaFileList, props.inputFileCustomily)
        isSuccessUpload.value = true
      }
    })
    .catch((err) => {
      errorUploadMessage.value = err.message ?? errorUploadMessage.value
      isSuccessUpload.value = false
      Logger.log('Error when uploading image', err)
    })
    .finally(async () => {
      if (isSuccessUpload.value) {
        const option_sort_id = props.optionSortId
        await setAiStyleTransferRecently(
          imageAITransferedLink.value,
          imageUploadUrl.value,
          option_sort_id,
          isStyleTransferVideo.value,
          isStyleTransferVideo.value && previewVideoUrl.value
            ? previewVideoUrl.value
            : undefined
        )
        customilyUpLoadingHandler()
        imageAITransferedLink.value = ''
        aiStyleTransferRecentlyIndexSelected.value = 0
      } else {
        loading.value = false
        isShowMessage.value = true
      }
    })
}

function hasEnoughNumberImages() {
  // kiểm tra đủ số image yêu cầu upload không
  const needed = Array.from({ length: Number(imageNumberUpload.value) }, (_, i) => i + 1);
  return needed.every(num => listImageUploadSelected.value.some((item: any) => item.photoNumber === num));
}

function hasEnoughCustomValueRequired() {
  if (!customConfig.value) return true
  const config = customConfig.value.find(
    (item:any) => item.required && (!item.customValue || item.customValue.toString().trim() === '')
  );
  if (config) {
    titleCustomConfigHasNotValue.value = config?.title
    try {
      Analytics.track('errors', {
        message: titleCustomConfigHasNotValue.value + ' is required'
      });
    } catch (e) {
      console.log(e)
    }
    return false
  } else {
    titleCustomConfigHasNotValue.value = ''
    return true
  }
}

const handleGenImageFromOnlyText = async () => {
  if (await isBlockedByVideoRateLimit()) return
  statusGenAIText.value = 'waiting'

  try {
    const promptCustom = customConfig.value.reduce((acc:any, item:any) => {
      acc[item.prompt] = item.customValue || '';
      return acc;
    }, {});

    const customilyOptions = getCustomilyOptions()
    const productVariants = getProductVariants()

    const mergedOptions = {
      ...customilyOptions,
      ...productVariants
    }

    const payload = {
      templateId: props.templateId ? props.templateId : templateIdSelected.value,
      id: props.customizationTemplate.id,
      custom_name: customYourName.value || '',
      prompt_custom: customConfig.value?.length ? JSON.stringify(promptCustom) : '',
      customily_options: Object.keys(mergedOptions).length
        ? JSON.stringify(mergedOptions)
        : ''
    }

    const imageTransferedLink = await transferTextToImage(payload)
    if (!imageTransferedLink) {
      throw {
        message: errorTransferImageMessage,
      }
    }

    statusGenAIText.value = 'waiting'
    startProgressBar()

    // vì link ảnh AI cần phải mất một thời gian mới có thể active
    // nên cần phải đợi một thời gian để link ảnh được active thì tiếp tục xử lí tiếp
    const isReady = await waitForImageReady(imageTransferedLink)
    if (isReady) {
      imageAITransferedLink.value = imageTransferedLink
      imageAiUrlSelectedForCheckout.value = imageTransferedLink
    } else {
      throw {
        message: errorTransferImageMessage,
      }
    }

    statusGenAIText.value = 'done'

    // clearInterval(pollingTimer)
    clearInterval(progressTimer)
    progressTimer = null

    progress.value = 100
    showProgress.value = false
    // Với flow only-text: coi output image là "input" cho cả style transfer/video.
    imageUploadUrl.value = imageTransferedLink
    imageSelected.value = imageTransferedLink

    if (!isStyleTransferVideo.value) {
      const fileName = `${sibFileNameStyleTransferImagePrefix}-${templateIdSelected.value}-${props.customizationTemplate.id}`
      const imageFileList = await convertImageLinkToFileList(
        imageTransferedLink!,
        fileName
      )
      changeFileImageCustomily(imageFileList, props.inputFileCustomily)
      isSuccessUpload.value = true
      saveStyleTransfered()

      if (isSuccessUpload.value) {
        customilyUpLoadingHandler()
        const option_sort_id = props.optionSortId
        await setAiStyleTransferRecently(
          imageAITransferedLink.value,
          imageUploadUrl.value,
          option_sort_id,
          false
        )
        imageAITransferedLink.value = ''
        aiStyleTransferRecentlyIndexSelected.value = 0
      } else {
        loading.value = false
        isShowMessage.value = true
      }
    } else {
      const fileName = `${sibFileNameStyleTransferImagePrefix}-${templateIdSelected.value}-${props.customizationTemplate.id}`
      const imageFileList = await convertImageLinkToFileList(
        imageTransferedLink!,
        fileName
      )
      changeFileImageCustomily(imageFileList, props.inputFileCustomily)

      styledImageUrlForVideo.value = imageTransferedLink!
      previewVideoUrl.value = ''
      await generateVideoFromStyledImage({
        imageForVideo: imageTransferedLink!,
        templateId: templateIdSelected.value,
      })
      isSuccessUpload.value = true
      saveStyleTransfered()

      if (isSuccessUpload.value) {
        customilyUpLoadingHandler()
        const option_sort_id = props.optionSortId
        await setAiStyleTransferRecently(
          imageAITransferedLink.value,
          imageUploadUrl.value,
          option_sort_id,
          true,
          undefined
        )
        imageAITransferedLink.value = ''
        aiStyleTransferRecentlyIndexSelected.value = 0
      } else {
        loading.value = false
        isShowMessage.value = true
      }
    }
  } catch (err) {
    console.error('Gen music error:', err)
  }
}

const startProgressBar = () => {
  progress.value = 0
  showProgress.value = true

  // Phase 1: 0 -> 90 (nhanh)
  progressTimer = setInterval(() => {
    if (progress.value < 90) {
      progress.value += Math.random() * 5
      if (progress.value > 90) progress.value = 90
    } else {
      // Phase 2: 90 -> 99 (chậm)
      progress.value += Math.random() * 0.3 // rất chậm
      if (progress.value > 99) progress.value = 99
    }
  }, 800)
}

function trackCustomizationInput(title: string, value: string) {
  try {
    const product = productStore.product
    Analytics.track('Input product page', {
      value: value,
      input_title: title,
      product_title: productStore?.product?.title,
      product_tags: productStore?.product?.tags,
      product_url: window.location.href,
    })
  } catch (e) {
    console.log(e)
  }
}
</script>

<style lang="scss">
.ai-style-transfer-recently {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  max-width: 320px;
  margin-bottom: 6px;

  &::-webkit-scrollbar-track {
    background-color: var(--background-color);
  }

  &::-webkit-scrollbar {
    height: 7px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #b4b4b4;
    border-radius: 1rem;
  }
  &__item {
    background-color: transparent;
    box-sizing: border-box;
    box-shadow: 0 0 2px 1px #0003;
    border: 3px solid #fff;
    width: 62px;
    height: 62px;
    transition: all 0.3s ease;
    cursor: pointer;
    margin: 5px 5px 3px 4px !important;

    &--active {
      border-color: var(--border-color-button);
    }

    &--image {
      width: 62px;
    }

    .ai-style-transfer-recently__media {
      width: 56px;
      height: 56px;
      object-fit: contain;
      display: block;
    }

    &--active{
      position: relative;
      &::before {
        content: '';
        position: absolute;
        width: 12px;
        height: 12px;
        right: 2px;
        bottom: 0;
        background: url('@/assets/images/icons/check-mark.svg');
        background-repeat: no-repeat;
        background-size: cover;
        z-index: var(--base-z-index);
      }
    }
  }
}
.style-transfer-video-create-wrap {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
}

/** Ghi chú xám, block (tránh display:inline của .customization-upload-image-wrapper-message). */
.style-transfer-video-note {
  display: block;
  width: 100%;
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 500;
  /* Ghi chữ: dùng text xám; --color-secondary trong theme là đỏ (#eb001b) */
  color: var(--text-color-secondary);
}

.style-transfer-video-note--error {
  color: var(--color-secondary);
}

.style-transfer-video-create-wrap .music-action-button + .style-transfer-video-note {
  margin-top: 8px;
}
.style-transfer-video-preview-wrap {
  margin: 10px 0;
  max-width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 8px;
  background: #000;
}

.style-transfer-video-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ai-style-transfer-history-title {
  font-weight: 600;
  margin: 14px 0 2px 0
}

.rate-limit-transfer-message {
  font-size: 12px;
  color: var(--color-secondary);
  margin-top: 8px;
  margin-bottom: 8px;
}

.customization-upload-image-wrapper + .cl_remove-image  {
  display: none;
}

.remove-custom-upload-image {
  padding: 14px;
}

.wrapper-style-transfer .cl_remove-image {
  display: none !important; 
}

.generate-loading {
  --loading-size: 16px;
  --loading-line-width: 2px;
  color: #ffffff;
  transform: translateX(-6px);
}

.generate-button {
  max-width: 170px;
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.disable-button {
  pointer-events: none;
}

.customily_option .customily-file-with-thumbnail .customily-file-input-thumbnail {
  display: none;
}

.customily_option .customily-file-with-thumbnail .cl-container {
  display: none;
}

.ai-video-container {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
}

.ai-video-watermark {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: -30%;
    background-image: var(--ai-video-watermark-image);
    background-repeat: repeat;
    background-size: 280px 160px;
    opacity: 1;
  }
}
</style>